import axiosInstance from "./http/axios_instance"
const http = axiosInstance("/protected",  null, "/forbidden")

const postValuation = (body) => http.post(`/valuation`, body);

const getMyValuation = (summary_id) => http.get("/valuation/review/" + summary_id)

const getMyValuations = (search_data) => http.post("/user_valuation_requests", search_data);

const getValuationHistory = (summary_id) => http.get("/valuation_history/" + summary_id);

const postValuationQuery = (body) => http.post("/valuation_history",body);

const postFileValuationQuery = (body) => http.post("/file_valuation_history", body);

const getValuationFile = (summary_id, filename, valuer_chat) => http.get("/file_valuation_history/" + summary_id + "/" + filename + "/" + valuer_chat);

const deleteNotifications = (summary_id) => http.post("/valuation_notifications/" + summary_id);

const setUnderReview = (summary_id) => http.put("/valuation/under_review/" + summary_id);
const setReopen = (summary_id) => http.put("/valuation/reopen/" + summary_id);

const setApproved = (summary_id, data) => http.put("/valuation/approve/" + summary_id, data);

const setRejected = (summary_id, cancellation_reason_id) => http.put("/valuation/reject/" + summary_id, {cancellation_reason_id});

const getCancellationReasons = () => http.get("/cancellation_reasons");

const setAmended = (summary_id, data) => http.put("/valuation/amend/" + summary_id, data);
const valuationAccuracyCheck = (property_id) => http.get("/valuation/check/" + property_id);
const getValuationTypes = () => http.get("/valuation_types")
const getValuationPurpose = () => http.get("/valuation_purpose")
const getFinvisePropertyTypes = () => http.get("/finvise_property_types")
const getValuationCategories = () => http.get("/valuation_categories")
const getValuationReportLength = (organisationId, propertyTypeId) => http.get("/valuation_report_length", {
    params: organisationId != null && propertyTypeId != null
        ? { organisation_id: organisationId, property_type_id: propertyTypeId }
        : {},
})
const getValuationPropertyTypes = (_type) => http.get(`/valuation_property_type/${_type}`)

const postManualValuation = (body) => http.post("/manual_valuation", body)

const SaveToPDF = (summary_id, data = {}) => {
    return http.post(`/save_to_pdf/${summary_id}`, data);
}
const transferValuation = (valuation_id, newClient) => http.put('/transfer_valuation/' + valuation_id, {
    "new_client": newClient,
})

const getOrganisationMembers = () => http.get(`/organisation_members`)

const getPDFStatus = (summary_id) => http.get("/valuation/pdf/" + summary_id)

const checkValuationRequest = (_request_id) => http.get("/valuation/status/" + _request_id);

const getValuationRequestDetails = (summary_id) => http.get("/valuation_request_details/" + summary_id)

const saveValuationRequestDetails = (body) => http.post("/valuation_request_details", body)

export default {
    postValuation,
    getMyValuations,
    getMyValuation,
    getValuationHistory,
    postValuationQuery,
    deleteNotifications,
    setUnderReview,
    setReopen,
    setApproved,
    setRejected,
    getCancellationReasons,
    setAmended,
    valuationAccuracyCheck,
    getValuationTypes,
    getValuationPurpose,
    postFileValuationQuery,
    getValuationFile,
    postManualValuation,
    getValuationCategories,
    getValuationReportLength,
    getValuationPropertyTypes,
    SaveToPDF,
    transferValuation,
    getOrganisationMembers,
    getFinvisePropertyTypes,
    getPDFStatus,
    checkValuationRequest,
    getValuationRequestDetails,
    saveValuationRequestDetails,
}
